/**
 * Demo Aggregate Accounts — Lab usernames + child drill fixture.
 * Extra filler rows so Lab-style pager (20/page) shows in demo.
 */

import type { AggregateAccountApiRow } from '@/api/map/aggregateAccounts'

const ROOT_A = '22222222-2222-4222-8222-222222222222'
const ROOT_B = '33333333-3333-4333-8333-333333333333'
const CHILD_A = '44444444-4444-4444-8444-444444444444'

const ROOT_DEMO: AggregateAccountApiRow[] = [
  {
    id: ROOT_A,
    username: 'fingerprintnrtm',
    name: 'fingerprintnrtm',
    level: 5,
    accessLevel: 'Master',
    creditLimit: '50000000',
    balanceUp: '-12507500', // Take ₹1,25,075
    postedPnl: '-12507500',
    availableCredit: '37492500', // credit + balanceUp (no exposure)
    status: 'active',
    currencyType: 'INR',
    createdAt: '2025-06-01T08:00:00.000Z',
  },
  {
    id: ROOT_B,
    username: 'fingerprintpointdm',
    name: 'fingerprintpointdm',
    level: 5,
    accessLevel: 'Master',
    creditLimit: '20000000',
    balanceUp: '8425000', // Give ₹84,250
    postedPnl: '8425000',
    availableCredit: '28425000',
    status: 'closed',
    currencyType: 'POINTS',
    createdAt: '2025-07-15T12:30:00.000Z',
  },
]

/** Filler so demo exceeds DEFAULT_PAGE_SIZE (20) and shows the pager. */
const DEMO_PAGE_FILLER: AggregateAccountApiRow[] = Array.from({ length: 19 }, (_, i) => {
  const n = i + 1
  const id = `55555555-5555-4555-8555-${String(n).padStart(12, '0')}`
  return {
    id,
    username: `demo-master-${n}`,
    name: `demo-master-${n}`,
    level: 5,
    accessLevel: 'Master',
    creditLimit: '1000000',
    balanceUp: '0',
    postedPnl: '0',
    availableCredit: '1000000',
    status: 'active' as const,
    currencyType: 'INR',
    createdAt: '2025-08-01T00:00:00.000Z',
  }
})

/** Root memberList (Lab Aggregate Accounts landing). */
export const DEMO_AGGREGATE_ACCOUNTS: AggregateAccountApiRow[] = [
  ...ROOT_DEMO,
  ...DEMO_PAGE_FILLER,
]

/** Direct children of fingerprintnrtm (Lab View Downline). */
export const DEMO_AGGREGATE_CHILDREN: Record<string, AggregateAccountApiRow[]> = {
  [ROOT_A]: [
    {
      id: CHILD_A,
      username: 'member-beta',
      name: 'member-beta',
      level: 6,
      accessLevel: 'Player',
      creditLimit: '2500000',
      balanceUp: '-150000', // Take ₹1,500
      postedPnl: '-150000',
      availableCredit: '2350000',
      status: 'active',
      currencyType: 'INR',
      createdAt: '2026-02-01T10:00:00.000Z',
    },
  ],
}

export function filterDemoAggregateAccounts(
  username: string,
  parentId?: string,
): AggregateAccountApiRow[] {
  const needle = username.trim().toLowerCase()
  const base = parentId
    ? (DEMO_AGGREGATE_CHILDREN[parentId] ?? [])
    : DEMO_AGGREGATE_ACCOUNTS
  if (!needle) return base
  return base.filter((r) => r.username.toLowerCase().includes(needle))
}
